// Premium content extensions (stats, process, industries, certifications, tech stack, FAQ)
// Merged into translations object via spread in translations.js

export const premiumIT = {
  caseStudies: {
    eyebrow: "Case Studies",
    title: "Risultati misurabili, non promesse",
    subtitle: "Quattro casi reali (clienti anonimizzati per NDA) con metriche pre/post intervento verificate.",
    cta: "Richiedi il case study completo",
    labels: { challenge: "Sfida", solution: "Intervento", duration: "Durata", before: "Prima", after: "Dopo" },
    items: [
      {
        sector: "E-commerce Moda",
        size: "PMI · 45 dipendenti",
        challenge: "Conversione bassa, gestione ordini manuale, costi pubblicitari fuori controllo.",
        solution: "Migrazione Shopify Plus, integrazione ERP, automazione marketing e ottimizzazione CRO.",
        duration: "4 mesi",
        metrics: [
          { label: "Tasso di conversione", before: "0.9%", after: "2.5%", delta: "+178%" },
          { label: "Tempo gestione ordini", before: "12 min", after: "2 min", delta: "-83%" },
          { label: "Fatturato annuo aggiuntivo", before: "—", after: "€420k", delta: "+€420k" },
        ],
      },
      {
        sector: "Studio Commercialisti",
        size: "20 professionisti",
        challenge: "Eccesso di lavoro amministrativo, scadenze fiscali a rischio, comunicazioni clienti caotiche.",
        solution: "Gestionale cloud, conservazione AgID, portale clienti e flussi automatizzati.",
        duration: "3 mesi",
        metrics: [
          { label: "Tempo amministrativo", before: "32h/sett", after: "8h/sett", delta: "-75%" },
          { label: "Nuovi clienti acquisiti", before: "+8/anno", after: "+22/anno", delta: "+175%" },
          { label: "Adempimenti AgID/SDI", before: "Manuali", after: "100% automatici", delta: "Full digital" },
        ],
      },
      {
        sector: "Manifatturiero · Componenti auto",
        size: "Media impresa · 180 addetti",
        challenge: "Fermi macchina imprevisti, scarso controllo qualità, mancato accesso a Industria 4.0.",
        solution: "IoT su 24 macchine, MES integrato con ERP, dashboard KPI live, dossier Transizione 5.0.",
        duration: "8 mesi",
        metrics: [
          { label: "Fermi macchina mensili", before: "42h", after: "23h", delta: "-45%" },
          { label: "Throughput produttivo", before: "100 baseline", after: "128", delta: "+28%" },
          { label: "Credito d'imposta ottenuto", before: "€0", after: "€186k", delta: "PNRR/T5.0" },
        ],
      },
      {
        sector: "Servizi B2B · Consulenza",
        size: "Boutique · 12 persone",
        challenge: "Pipeline commerciale opaca, lead di scarsa qualità, processo di vendita improvvisato.",
        solution: "CRM HubSpot, lead scoring automatico, sequenze email personalizzate, dashboard revenue.",
        duration: "5 mesi",
        metrics: [
          { label: "Lead qualificati (MQL)", before: "18/mese", after: "58/mese", delta: "+222%" },
          { label: "Ciclo di vendita medio", before: "92 giorni", after: "47 giorni", delta: "-49%" },
          { label: "ARR (Annual Recurring Revenue)", before: "€620k", after: "€1.1M", delta: "+77%" },
        ],
      },
    ],
  },
  stats: {
    eyebrow: "Numeri che parlano",
    title: "Risultati concreti per i nostri clienti",
    items: [
      { value: "150+", label: "Aziende servite", sub: "In Italia ed Europa" },
      { value: "98%", label: "Clienti soddisfatti", sub: "NPS verificato" },
      { value: "10+", label: "Anni di esperienza", sub: "in consulenza IT" },
      { value: "€2.3M", label: "ROI generato", sub: "per i clienti nel 2024" },
    ],
  },
  process: {
    eyebrow: "Metodologia",
    title: "Un processo collaudato in 5 fasi",
    subtitle: "Trasparente, misurabile, orientato ai risultati. Ti seguiamo passo dopo passo.",
    steps: [
      { n: "01", title: "Discovery Call", desc: "Analisi delle tue esigenze, obiettivi e contesto operativo in una sessione gratuita di 30 minuti." },
      { n: "02", title: "Audit & Diagnosi", desc: "Mappatura completa di processi, strumenti e infrastruttura. Identifichiamo i gap e le opportunità di valore." },
      { n: "03", title: "Roadmap Strategica", desc: "Piano operativo personalizzato con priorità, KPI misurabili e cronoprogramma realistico." },
      { n: "04", title: "Implementazione", desc: "Esecuzione affiancata. Tecnologie, automazioni, formazione del team. Trasferimento di competenze incluso." },
      { n: "05", title: "Monitoraggio & Ottimizzazione", desc: "Reportistica mensile, ottimizzazione continua e supporto prioritario su ogni iterazione." },
    ],
  },
  industries: {
    eyebrow: "Settori",
    title: "Esperienza verticale in 8 settori chiave",
    subtitle: "Soluzioni su misura per ogni filiera.",
    items: [
      { title: "E-commerce & Retail", desc: "Shopify, WooCommerce, Magento. Integrazione ERP, automazione magazzino, conversioni." },
      { title: "Studi Professionali", desc: "Avvocati, commercialisti, consulenti. Gestionali, fatturazione, conservazione digitale." },
      { title: "Manifatturiero", desc: "Industria 4.0, IoT, MES, integrazioni macchine, Piano Transizione 5.0." },
      { title: "Servizi B2B", desc: "CRM, automazione marketing, lead scoring, customer journey mapping." },
      { title: "Hospitality & Food", desc: "PMS, channel manager, cassa fiscale, loyalty digitale." },
      { title: "Sanità privata", desc: "Cartella clinica digitale, GDPR sanitario, prenotazioni online, telemedicina." },
      { title: "Real Estate", desc: "CRM immobiliare, virtual tour, lead generation, valutazioni AI-assisted." },
      { title: "Formazione & EduTech", desc: "LMS, video on-demand, certificazioni digitali, automazione iscrizioni." },
    ],
  },
  certifications: {
    eyebrow: "Certificazioni & Conformità",
    title: "Standard italiani ed europei di alto livello",
    subtitle: "Operiamo nel pieno rispetto delle normative IT, sicurezza e protezione dati vigenti in Italia e nell'Unione Europea.",
    groupCompliance: "Conformità & Normative",
    groupSecurity: "Sicurezza & Qualità",
    groupAuth: "Identità Digitale",
    trustEyebrow: "Made in EU",
    trustTitle: "Data center europei · GDPR-first",
    trustDesc: "Tutti i dati dei nostri clienti vengono trattati e conservati esclusivamente all'interno dell'Unione Europea, con cifratura AES-256 at-rest e TLS 1.3 in-transit. Nessun trasferimento extra-UE.",
    items: [
      { code: "GDPR", name: "Regolamento UE 2016/679", desc: "Trattamento dati personali conforme al GDPR. DPIA, registri trattamenti e privacy by design.", group: "compliance" },
      { code: "NIS2", name: "Direttiva UE 2022/2555", desc: "Cybersecurity, gestione del rischio e notifica incidenti per soggetti essenziali e importanti.", group: "compliance" },
      { code: "eIDAS", name: "Regolamento UE 910/2014", desc: "Firma elettronica qualificata, sigilli, marche temporali e identità digitale europea.", group: "compliance" },
      { code: "AgID", name: "Linee Guida AgID", desc: "Conservazione digitale a norma, conformità Codice Amministrazione Digitale (CAD).", group: "compliance" },
      { code: "ISO/IEC 27001", name: "Sistema Gestione Sicurezza Informazioni", desc: "Framework di sicurezza riconosciuto a livello internazionale per la gestione dei dati.", group: "security" },
      { code: "ISO 9001", name: "Sistema Gestione Qualità", desc: "Processi di consulenza tracciati, misurati e in miglioramento continuo.", group: "security" },
      { code: "Cybersecurity Act", name: "Regolamento UE 2019/881", desc: "Schemi europei di certificazione cybersecurity (ENISA).", group: "security" },
      { code: "PSD2", name: "Direttiva UE 2015/2366", desc: "Strong Customer Authentication, Open Banking e pagamenti elettronici sicuri.", group: "security" },
      { code: "SPID", name: "Sistema Pubblico Identità Digitale", desc: "Integrazioni con SPID per autenticazione cittadini e PA.", group: "auth" },
      { code: "CIE 3.0", name: "Carta d'Identità Elettronica", desc: "Login federato con CIE per servizi pubblici e privati abilitati.", group: "auth" },
      { code: "PEC & SDI", name: "Posta Elettronica Certificata · Sistema di Interscambio", desc: "Fatturazione elettronica B2B/B2C e comunicazioni certificate verso la PA.", group: "auth" },
      { code: "PNRR", name: "Partner Transizione Digitale", desc: "Supporto pratiche Voucher Digitalizzazione, Industria 4.0, Transizione 5.0.", group: "auth" },
    ],
  },
  techStack: {
    eyebrow: "Tecnologie & Partner",
    title: "Lo stack che usiamo quotidianamente",
    subtitle: "Tecnologie consolidate, scalabili e con il giusto rapporto valore-costo.",
    categories: [
      { name: "Cloud & Infrastructure", items: ["Microsoft Azure", "AWS", "Google Cloud", "OVH Cloud Europe", "Aruba Cloud"] },
      { name: "Business & Productivity", items: ["Microsoft 365", "Google Workspace", "Slack", "Notion", "Asana"] },
      { name: "CRM & Sales", items: ["HubSpot", "Salesforce", "Pipedrive", "Zoho CRM", "Brevo"] },
      { name: "E-commerce", items: ["Shopify", "WooCommerce", "Magento 2", "PrestaShop", "BigCommerce"] },
      { name: "Pagamenti", items: ["Nexi", "Viva.com", "Stripe", "PayPal", "Satispay"] },
      { name: "Automazione & AI", items: ["Make (Integromat)", "Zapier", "n8n", "OpenAI API", "Anthropic Claude"] },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Domande frequenti",
    subtitle: "Le risposte alle domande più comuni dei nostri clienti.",
    items: [
      { q: "Quanto tempo serve per vedere i primi risultati?", a: "Dipende dall'intervento, ma in media i primi risultati misurabili (riduzione tempi, conversioni, KPI) emergono entro 30-60 giorni. Per progetti più strutturati di trasformazione digitale, fissiamo milestone trimestrali condivise." },
      { q: "Lavorate solo con aziende italiane?", a: "No. Lavoriamo con clienti in Italia e in tutta l'Unione Europea. Conosciamo le normative locali (GDPR, eIDAS, NIS2, fatturazione elettronica) e parliamo italiano, inglese e francese a livello professionale." },
      { q: "Posso pagare con bonifico SEPA o fattura elettronica B2B?", a: "Sì. Per i pacchetti Enterprise e Premium Partnership emettiamo fattura elettronica via SDI con pagamento a 30 giorni. Per pacchetti standard accettiamo carta (Nexi/Viva), Apple Pay, Google Pay e Satispay." },
      { q: "Posso accedere ai voucher digitalizzazione o ai bandi PNRR?", a: "Assolutamente. Supportiamo i clienti nella richiesta di Voucher Digitalizzazione, Bandi Camera di Commercio, Credito d'imposta Industria 4.0 e Transizione 5.0. Forniamo documentazione tecnica e supporto al commercialista." },
      { q: "Garantite la riservatezza dei dati aziendali?", a: "Sì. Firmiamo NDA prima di ogni discovery. I dati vengono trattati secondo GDPR, conservati su data center UE, cifrati at-rest e in-transit. Forniamo DPIA su richiesta." },
      { q: "Cosa succede se non sono soddisfatto?", a: "Per i pacchetti Starter e Business offriamo una garanzia di soddisfazione: se entro 7 giorni dalla consulenza non sei soddisfatto, rimborsiamo il 100% senza domande." },
      { q: "Lavorate anche in modalità retainer / continuativa?", a: "Sì. Il pacchetto Premium Partnership è pensato per relazioni di lungo termine con SLA dedicato, supporto prioritario e ore mensili garantite. Modello su misura in base al volume." },
      { q: "Posso vedere casi studio prima di decidere?", a: "Certamente. Su richiesta condividiamo case study anonimizzati con metriche pre/post intervento, settore e ruolo del cliente. Alcuni clienti accettano anche reference call dirette." },
    ],
  },
  servicesDetailed: {
    items: [
      {
        title: "Consulenza Informatica",
        desc: "Analisi strategica delle esigenze aziendali e individuazione delle migliori soluzioni tecnologiche, con valutazione ROI e roadmap implementativa.",
        features: ["Audit completo dell'infrastruttura IT", "Selezione vendor e software", "Valutazione cyber-risk", "Business case con ROI a 12-36 mesi"],
      },
      {
        title: "Digitalizzazione dei Processi",
        desc: "Mappatura, ottimizzazione e automazione dei flussi di lavoro. Riduzione dei tempi operativi fino al 60% con integrazioni intelligenti.",
        features: ["Process mining e BPM", "Automazioni RPA e workflow", "Integrazione ERP/CRM/eCommerce", "Document management & conservazione AgID"],
      },
      {
        title: "Supporto Tecnologico",
        desc: "Assistenza specialistica su software, strumenti digitali e infrastrutture con SLA garantiti e ticket prioritario.",
        features: ["Help desk multilivello L1-L3", "Monitoring 24/7 (Premium)", "Backup e disaster recovery", "Manutenzione evolutiva continua"],
      },
      {
        title: "Strategia Digitale",
        desc: "Pianificazione e miglioramento dell'organizzazione tecnologica con orizzonte 12-36 mesi e governance dei dati.",
        features: ["IT Strategy & Governance", "Data strategy & analytics", "Roadmap multi-anno", "Change management & formazione"],
      },
    ],
  },
};

export const premiumEN = {
  caseStudies: {
    eyebrow: "Case Studies",
    title: "Measurable results, not promises",
    subtitle: "Four real cases (clients anonymized under NDA) with verified pre/post metrics.",
    cta: "Request the full case study",
    labels: { challenge: "Challenge", solution: "Solution", duration: "Duration", before: "Before", after: "After" },
    items: [
      {
        sector: "Fashion E-commerce",
        size: "SMB · 45 employees",
        challenge: "Low conversion, manual order handling, out-of-control ad costs.",
        solution: "Migration to Shopify Plus, ERP integration, marketing automation, CRO optimization.",
        duration: "4 months",
        metrics: [
          { label: "Conversion rate", before: "0.9%", after: "2.5%", delta: "+178%" },
          { label: "Order handling time", before: "12 min", after: "2 min", delta: "-83%" },
          { label: "Additional annual revenue", before: "—", after: "€420k", delta: "+€420k" },
        ],
      },
      {
        sector: "Accounting firm",
        size: "20 professionals",
        challenge: "Excessive administrative work, tax deadlines at risk, chaotic client comms.",
        solution: "Cloud practice management, AgID-compliant preservation, client portal and automated flows.",
        duration: "3 months",
        metrics: [
          { label: "Admin time", before: "32h/week", after: "8h/week", delta: "-75%" },
          { label: "New clients acquired", before: "+8/year", after: "+22/year", delta: "+175%" },
          { label: "AgID/SDI compliance", before: "Manual", after: "100% automated", delta: "Full digital" },
        ],
      },
      {
        sector: "Manufacturing · Auto parts",
        size: "Mid-size · 180 staff",
        challenge: "Unexpected machine downtime, poor real-time quality control, no access to Industry 4.0.",
        solution: "IoT on 24 machines, MES integrated with ERP, live KPI dashboard, Transition 5.0 dossier.",
        duration: "8 months",
        metrics: [
          { label: "Monthly downtime", before: "42h", after: "23h", delta: "-45%" },
          { label: "Production throughput", before: "100 baseline", after: "128", delta: "+28%" },
          { label: "Tax credit obtained", before: "€0", after: "€186k", delta: "PNRR/T5.0" },
        ],
      },
      {
        sector: "B2B Services · Consulting",
        size: "Boutique · 12 people",
        challenge: "Opaque sales pipeline, low-quality leads, improvised sales process.",
        solution: "HubSpot CRM, automatic lead scoring, personalized email sequences, revenue dashboard.",
        duration: "5 months",
        metrics: [
          { label: "Marketing-qualified leads", before: "18/month", after: "58/month", delta: "+222%" },
          { label: "Average sales cycle", before: "92 days", after: "47 days", delta: "-49%" },
          { label: "ARR (Annual Recurring Revenue)", before: "€620k", after: "€1.1M", delta: "+77%" },
        ],
      },
    ],
  },
  stats: {
    eyebrow: "Numbers that matter",
    title: "Concrete results for our clients",
    items: [
      { value: "150+", label: "Companies served", sub: "Italy & Europe" },
      { value: "98%", label: "Happy clients", sub: "verified NPS" },
      { value: "10+", label: "Years of experience", sub: "in IT consulting" },
      { value: "€2.3M", label: "ROI generated", sub: "for clients in 2024" },
    ],
  },
  process: {
    eyebrow: "Methodology",
    title: "A proven 5-step process",
    subtitle: "Transparent, measurable, results-driven. We guide you every step of the way.",
    steps: [
      { n: "01", title: "Discovery Call", desc: "We analyze your needs, goals, and operating context in a free 30-minute session." },
      { n: "02", title: "Audit & Diagnosis", desc: "Complete mapping of processes, tools, and infrastructure. We identify gaps and value opportunities." },
      { n: "03", title: "Strategic Roadmap", desc: "Tailored operational plan with priorities, measurable KPIs, and a realistic timeline." },
      { n: "04", title: "Implementation", desc: "Hands-on execution. Tech, automation, team training. Knowledge transfer included." },
      { n: "05", title: "Monitoring & Optimization", desc: "Monthly reporting, continuous improvement, and priority support on every iteration." },
    ],
  },
  industries: {
    eyebrow: "Industries",
    title: "Vertical expertise in 8 key sectors",
    subtitle: "Tailored solutions for every supply chain.",
    items: [
      { title: "E-commerce & Retail", desc: "Shopify, WooCommerce, Magento. ERP integration, warehouse automation, conversions." },
      { title: "Professional firms", desc: "Lawyers, accountants, consultants. Practice management, billing, digital preservation." },
      { title: "Manufacturing", desc: "Industry 4.0, IoT, MES, machine integrations, Italian Transition 5.0 plan." },
      { title: "B2B Services", desc: "CRM, marketing automation, lead scoring, customer journey mapping." },
      { title: "Hospitality & Food", desc: "PMS, channel manager, fiscal POS, digital loyalty." },
      { title: "Private Healthcare", desc: "EHR, healthcare GDPR, online booking, telehealth." },
      { title: "Real Estate", desc: "Real-estate CRM, virtual tours, lead generation, AI-assisted appraisals." },
      { title: "Education & EduTech", desc: "LMS, on-demand video, digital certifications, enrolment automation." },
    ],
  },
  certifications: {
    eyebrow: "Certifications & Compliance",
    title: "High-grade Italian & European standards",
    subtitle: "We operate in full compliance with current IT, security, and data-protection regulations in Italy and the European Union.",
    groupCompliance: "Compliance & Regulations",
    groupSecurity: "Security & Quality",
    groupAuth: "Digital Identity",
    trustEyebrow: "Made in EU",
    trustTitle: "European data centers · GDPR-first",
    trustDesc: "All our clients' data is processed and stored exclusively within the European Union, with AES-256 at-rest encryption and TLS 1.3 in-transit. No extra-EU transfers.",
    items: [
      { code: "GDPR", name: "EU Regulation 2016/679", desc: "Personal data processing compliant with GDPR. DPIA, processing records, privacy by design.", group: "compliance" },
      { code: "NIS2", name: "EU Directive 2022/2555", desc: "Cybersecurity, risk management, and incident notification for essential and important entities.", group: "compliance" },
      { code: "eIDAS", name: "EU Regulation 910/2014", desc: "Qualified electronic signatures, seals, time stamps, and European digital identity.", group: "compliance" },
      { code: "AgID", name: "Italian AgID Guidelines", desc: "Compliant digital preservation, compliance with Italian Digital Administration Code (CAD).", group: "compliance" },
      { code: "ISO/IEC 27001", name: "Information Security Management", desc: "Internationally recognized security framework for data management.", group: "security" },
      { code: "ISO 9001", name: "Quality Management System", desc: "Consulting processes tracked, measured, and continuously improved.", group: "security" },
      { code: "Cybersecurity Act", name: "EU Regulation 2019/881", desc: "European cybersecurity certification schemes (ENISA).", group: "security" },
      { code: "PSD2", name: "EU Directive 2015/2366", desc: "Strong Customer Authentication, Open Banking, and secure electronic payments.", group: "security" },
      { code: "SPID", name: "Italian Public Digital Identity", desc: "SPID integrations for citizen and Public Administration authentication.", group: "auth" },
      { code: "CIE 3.0", name: "Italian Electronic ID Card", desc: "Federated login with CIE for enabled public and private services.", group: "auth" },
      { code: "PEC & SDI", name: "Certified Email · Italian Exchange System", desc: "B2B/B2C e-invoicing and certified communications with the Italian PA.", group: "auth" },
      { code: "PNRR", name: "Digital Transition Partner", desc: "Support with Digitalization Vouchers, Industry 4.0 and Transition 5.0.", group: "auth" },
    ],
  },
  techStack: {
    eyebrow: "Tech & Partners",
    title: "The stack we use every day",
    subtitle: "Proven, scalable technologies with the right value-cost ratio.",
    categories: [
      { name: "Cloud & Infrastructure", items: ["Microsoft Azure", "AWS", "Google Cloud", "OVH Cloud Europe", "Aruba Cloud"] },
      { name: "Business & Productivity", items: ["Microsoft 365", "Google Workspace", "Slack", "Notion", "Asana"] },
      { name: "CRM & Sales", items: ["HubSpot", "Salesforce", "Pipedrive", "Zoho CRM", "Brevo"] },
      { name: "E-commerce", items: ["Shopify", "WooCommerce", "Magento 2", "PrestaShop", "BigCommerce"] },
      { name: "Payments", items: ["Nexi", "Viva.com", "Stripe", "PayPal", "Satispay"] },
      { name: "Automation & AI", items: ["Make (Integromat)", "Zapier", "n8n", "OpenAI API", "Anthropic Claude"] },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Frequently asked questions",
    subtitle: "Answers to the most common questions from our clients.",
    items: [
      { q: "How long until I see results?", a: "It depends, but on average measurable results (time saved, conversions, KPIs) appear within 30-60 days. For structured digital transformation, we set quarterly milestones." },
      { q: "Do you only work with Italian companies?", a: "No. We work with clients in Italy and across the EU. We know local regulations (GDPR, eIDAS, NIS2, e-invoicing) and speak Italian, English, and French professionally." },
      { q: "Can I pay via SEPA bank transfer or B2B e-invoice?", a: "Yes. For Enterprise and Premium Partnership we issue SDI e-invoices with 30-day terms. For standard packages we accept cards (Nexi/Viva), Apple Pay, Google Pay, and Satispay." },
      { q: "Can I access digitalization vouchers or PNRR funds?", a: "Absolutely. We support clients with Digitalization Vouchers, Chamber of Commerce calls, Industry 4.0 and Transition 5.0 tax credits. We provide technical documentation and accountant support." },
      { q: "Do you guarantee data confidentiality?", a: "Yes. We sign NDAs before every discovery. Data is processed under GDPR, stored on EU data centers, encrypted at rest and in transit. DPIAs available on request." },
      { q: "What if I'm not satisfied?", a: "For Starter and Business packages we offer a satisfaction guarantee: if within 7 days of the consultation you're not happy, we refund 100% no questions asked." },
      { q: "Do you offer retainer / continuous engagements?", a: "Yes. The Premium Partnership package is designed for long-term relationships with dedicated SLA, priority support, and guaranteed monthly hours. Custom model based on volume." },
      { q: "Can I see case studies before deciding?", a: "Of course. On request we share anonymized case studies with pre/post metrics, sector, and client role. Some clients also agree to direct reference calls." },
    ],
  },
  servicesDetailed: {
    items: [
      { title: "IT Consulting", desc: "Strategic analysis of business needs and identification of best-fit technology solutions, with ROI evaluation and implementation roadmap.", features: ["Full IT infrastructure audit", "Vendor & software selection", "Cyber-risk assessment", "Business case with 12-36 month ROI"] },
      { title: "Process Digitalization", desc: "Mapping, optimization, and automation of workflows. Up to 60% reduction in operational times via smart integrations.", features: ["Process mining and BPM", "RPA and workflow automation", "ERP/CRM/eCommerce integration", "Document management & AgID-compliant preservation"] },
      { title: "Tech Support", desc: "Specialist support on software, digital tools, and infrastructures with guaranteed SLAs and priority ticketing.", features: ["Multi-level help desk L1-L3", "24/7 monitoring (Premium)", "Backup and disaster recovery", "Continuous evolutionary maintenance"] },
      { title: "Digital Strategy", desc: "Planning and improvement of the technology organization with a 12-36 month horizon and data governance.", features: ["IT Strategy & Governance", "Data strategy & analytics", "Multi-year roadmap", "Change management & training"] },
    ],
  },
};
